Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

$(document).ready(function () {
  // console.log(`theme.collapsibles.init`,theme.collapsibles.init);
  let collapsiblesInit = theme.collapsibles.init;

  theme.collapsibles.init = function () {
    collapsiblesInit();
    console.log("Init Match height");
    try{
    $(".main-collection-info-wrapper").matchHeight({
      byRow: true,
      property: "height",
      target: null,
      remove: false,
    });
  }
  catch(ex){}
  };
});

$(document).on("click", ".rca-subscription-form__button", function () {
  $(this)
    .siblings(".rca-subscription-form__button")
    .removeClass("rca-subscription-form__button--selected");
  $(this).addClass("rca-subscription-form__button--selected");
  let currentType = $(this).data("type");
  $(this)
    .closest(".rca-subscription-form")
    .attr("data-selected-type", currentType);
  $(this).closest(".product-single__meta").find(".rca-subscription-form__frequency-selector").change(); 
  $(this).closest(".product-single__meta-recurring").find(".rca-subscription-form__frequency-selector").change();  
  // $(this).closest(".form").append("<input type='hidden' name='type' value='" + currentType + "'>");
}); 

$(document).on(
  "change",
  ".rca-subscription-form__frequency-selector",
  function () {
    let currentType = $(this)
      .closest(".rca-subscription-form")
      .attr("data-selected-type"); 
    let formAddToCart = $(this).closest(".product-single__meta").find(".product-single__form");
    formAddToCart.find(`[name="selling_plan"]`).remove();
    let currentFrequency = $(this).val();

    if (currentType == "recurring" && currentFrequency && currentFrequency != "null")  {   
      $(this).attr("name","selling_plan");   
      formAddToCart.append(`<input type="hidden" name="selling_plan" value="${currentFrequency}">`)
    } else {
      formAddToCart.find(`[name="selling_plan"]`).remove();
      $(this).removeAttr("name"); 
    }   
    // $(this).closest(".form").append("<input type='hidden' name='type' value='" + currentType + "'>");
  }
);

document.addEventListener(
  "ajaxProduct:added",
  function (evt) {

    if(window.SuperCart){
      SuperCart.ShowCartfn(); 
      }
  }.bind(this)
);
let FormStatus = {
  loading: false,
};
$(".product-full-wrapper").submit(function (evt) {
  evt.preventDefault();

  if (FormStatus.loading) {
    return;
  }

  // Loading indicator on add to cart button
  $(this).find(".add-to-cart").addClass("btn--loading");

  FormStatus.loading = true;
  let currentQuantity = $(this).find('.js-qty__num').val();
  var data = theme.utils.serialize(this);
  if(data && !data.includes('quantity') )
  {
    data+=`&quantity=${currentQuantity}`;
  } 
 

  fetch(theme.routes.cartAdd, {
    method: "POST",
    body: data,
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    },
  })
    .then((response) => response.json())
    .then(
      function (data) {
        if (data.status === 422) {
          this.error(data);
        } else {
          var product = data;
          if(window.SuperCart){
            SuperCart.ShowCartfn(); 
            }
        }
        FormStatus.loading = false;
        $(this).find(".add-to-cart").removeClass("btn--loading");
      }.bind(this)
    );
});

window.cachedProducts = {};

let doVariantSelect = (variant, context, product) => {
  let saleValue =
    ((variant.compare_at_price - variant.price) * 100.0) /
    variant.compare_at_price;
  saleValue = Math.round(Math.ceil(saleValue) / 5) * 5;
  let price, compare_at_price;
  let subscriptionType = $(".rca-subscription-form:not(.no-subscription)", context).attr(
    "data-selected-type"
  ); 
  // let variantImageId = variant.featured_image;
  let variantImage = variant.featured_image; 

  if (variantImage && variantImage.src) {
    $(`.main-collection-image`, context).attr("src", variantImage.src);
  } 

  // SALE PRICE
 
  price = variant.price; 
  if (subscriptionType == "recurring") {
    compare_at_price = variant.price;
    price = variant.price * 0.7 ; 
  } else { 
    compare_at_price = variant.compare_at_price;
  }

  let compareHTML =
    compare_at_price > 0
      ? `<span class="price-compare">${Shopify.formatMoney(
          compare_at_price
        ).replace(".00", "")}</span>`
      : "";
  let priceHtml = `<span class="price-html">${Shopify.formatMoney(
    price
  ).replace(".00", "")}</span>`;
  $(".grid-product__price", context).html(`${compareHTML}${priceHtml}`);
  // ADDTO CART
  $(".add-to-cart", context).attr("data-pid", variant.id);
  $('.product-single__variants',context).val(variant.id)   

};
let doDisabledVariantCHeck = (context, product) => {
  let options = {};
  $("[single-variant-option]").each(function (el) {
    options[1] = $('[data-index="option1"]:checked', context).val() ?? null;
    options[2] = $('[data-index="option2"]:checked', context).val() ?? null;
    options[3] =
      $('[data-index="option2"]:checked', context).data("value") ?? null;
    let optionIndex = $(this).data("option-index").replace("option", "");
    let value = $(this).data("value");

    if (optionIndex) {
      options[optionIndex] = value;
    }
    let singlevariant = product.variants.filter((variant) => {
      return (
        variant.option1 === options[1] &&
        variant.option2 === options[2] &&
        variant.option3 === options[3]
      );
    });

    if (singlevariant && singlevariant.length > 0) {
      $(this)
        .attr("data-variant-id", singlevariant[0].id)
        .removeClass("disabled");
    } else {
      $(this).removeAttr("data-variant-id").addClass("disabled");
    }
  });
};
let selectProductVariant = (context, product) => {
  let options = {};

  options[1] = $('[data-index="option1"]:checked', context).val() ?? null;
  options[2] = $('[data-index="option2"]:checked', context).val() ?? null;
  options[3] = $('[data-index="option2"]:checked').data("value") ?? null;
  let variants = product.variants.filter((variant) => {
    return (
      variant.option1 === options[1] &&
      variant.option2 === options[2] &&
      variant.option3 === options[3]
    );
  });
  doDisabledVariantCHeck();

  if (variants && variants.length > 0) {
    $(".add-to-cart-cbd", context)
      .removeClass("disabled")
      .removeAttr("disabled");
    doVariantSelect(variants[0], context, product);
  } else {
    $(".add-to-cart-cbd", context)
      .addClass("disabled")
      .attr("disabled", "disabled");
  }
};

let doFindProduct = async function (EL) {
  let context = $(EL).closest(".main-collection-single-wrapper");
  let productHandle = context.data("handle");
  let product;
  $(".add-to-cart-cbd", context).text("Applying...");
  if (window.cachedProducts[productHandle]) {
    product = window.cachedProducts[productHandle];
  } else {
    let data = await jQuery.getJSON(`/products/${productHandle}.js`);
    if (!data) {
      return;
    }
    product = data;  
    window.cachedProducts[productHandle] = product;
  }
  $(".add-to-cart-cbd", context).text("Add to cart");

  selectProductVariant(context, product);
};
$(".main-collection-single-wrapper input[data-index]").change(function (e) {
  doFindProduct(this);
});
$(".main-collection-single-wrapper .rca-subscription-form__button").click(
  function () {
    let This = this;
    setTimeout(() => {
      doFindProduct(This);
    }, 10);
  }
);
$(document).on(
  "click",
  ".main-collection-single-wrapper .plus-btn,.main-collection-single-wrapper .minus-btn",
  function (el) {
    el.preventDefault();
    let isPlus = $(this).hasClass("plus-btn");
    let QtyInput = $(this)
      .closest(".quantity-selector")
      .find('[name="quantity"]');
    let qty = QtyInput.val();
    if (isPlus) {
      qty++;
    } else {
      qty--;
    }
    if (qty > 0) {
      QtyInput.val(qty);
    }
  }
);
$(document).on(
  "click",
  ".main-collection-single-wrapper .add-to-cart-cbd",
  function (e) {
    e.preventDefault();
    e.stopPropagation();
     
    let context = $(this).closest(".main-collection-single-wrapper");
    let variantId = $(this).attr("data-pid");
    let mainBtn= $(this);
    let quantity = $(this)
      .closest(".main-collection-single-wrapper")
      .find(".js-qty__num");
    $(this).addClass("btn--loading");   
    let params = {
      id: variantId,
      quantity: quantity.val(),
    }
    console.log('params--', params)
    let isSubscription =$(this).closest(".main-collection-single-wrapper").find(".rca-subscription-form").attr("data-selected-type");
    if(isSubscription=='recurring')
    {  
      params.selling_plan = $(this).closest(".main-collection-single-wrapper")
                            .find(".rca-subscription-form__frequency-selector").val()
    }     
 

    fetch(theme.routes.cartAdd, {
      method: "POST", 
      body: JSON.stringify(params), 
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then(
        function (data) {  
          mainBtn.removeAttr('disabled')
          mainBtn.removeClass('disabled');
          if (data.status === 422) {
            this.error(data);
          } else {
            var product = data;
            doDataLayerPush(product);
            if(window.SuperCart){
              SuperCart.ShowCartfn(); 
            }
            SLIDECART_OPEN()  
          } 

 
          //   FormStatus.loading = false;
          $(this).removeClass("btn--loading");
        }.bind(this)
      );
  }
);

function doAddtoCart({ id, quantity, params, callback }) {
  fetch(theme.routes.cartAdd, {
    method: "POST",
    body: JSON.stringify({
      id: id,
      quantity: quantity,
      properties: params,
    }),
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => response.json())
    .then(
      function (data) {
        if (data.status === 422) {
          this.error(data);
        } else {
          var product = data;
          doDataLayerPush(product);  
          if(window.SuperCart){
            SuperCart.ShowCartfn(); 
            }
        } 
        //   FormStatus.loading = false;
        if (callback) {
          callback();
        }
      }.bind(this)
    );
}

function doDataLayerPush(product){
 
  if(window.dataLayer && product){
  dataLayer.push({ 'ecommerce': null });
  dataLayer.push({
    'event': 'add_to_cart',
    'ecommerce': {
        'items': [{
        'item_id': product.product_id , 
        'item_name': product.product_title,
        'item_brand': product.vendor,
        'item_category': product.product_type,
        'item_variant': product.sku, 
        'item_variant_id': product.variant_id,  
        'currency': 'USD',
        'price': product.price/100, 
        }]      
      }
    });
  } 
}

window.addEventListener('error', function (e) {
  //It Will handle JS errors 

  console.log(e); 
})

window.SLIDECART_ADDED_TO_CART=function(e){
console.log(`Tracking Add to Cart To GTM`);
doDataLayerPush(e);  

}

